/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Toast_Coins_AddedInputs */

const en_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1,500 Coins added!`)
};

const ar_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const de_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const es_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const fr_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const it_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const ja_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const ko_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const pt_br_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const ru_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const th_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const tr_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const zh_cn_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (``)
};

const zh_tw_toast_coins_added = /** @type {(inputs: Toast_Coins_AddedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已入帳 ${i?.number} 金幣！`)
};

/**
* | output |
* | --- |
* | "1,500 Coins added!" |
*
* @param {Toast_Coins_AddedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const toast_coins_added = /** @type {((inputs: Toast_Coins_AddedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Coins_AddedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_toast_coins_added(inputs)
	if (locale === "ar") return ar_toast_coins_added(inputs)
	if (locale === "de") return de_toast_coins_added(inputs)
	if (locale === "es") return es_toast_coins_added(inputs)
	if (locale === "fr") return fr_toast_coins_added(inputs)
	if (locale === "it") return it_toast_coins_added(inputs)
	if (locale === "ja") return ja_toast_coins_added(inputs)
	if (locale === "ko") return ko_toast_coins_added(inputs)
	if (locale === "pt_br") return pt_br_toast_coins_added(inputs)
	if (locale === "ru") return ru_toast_coins_added(inputs)
	if (locale === "th") return th_toast_coins_added(inputs)
	if (locale === "tr") return tr_toast_coins_added(inputs)
	if (locale === "zh_cn") return zh_cn_toast_coins_added(inputs)
	return zh_tw_toast_coins_added(inputs)
});